import { putApiGalaxyServer } from 'services';

export interface SetTeamAiEnabledPayload {
  teamId: number;
  aiEnabled: boolean;
}

export interface SetTeamAiEnabledResponse {
  teamId: string;
  aiEnabled: boolean;
  /** Whether Galaxy's team lookup row took the new value right away. */
  searchTeamUpdated: boolean;
}

/**
 * Turn a team's AI suggestions on or off through galaxy-server's ai-server
 * bridge. The route is tenant/realm scoped, so callers pass the team's
 * headers in `config`.
 */
export const setTeamAiEnabledApi = ({
  params: { teamId, aiEnabled },
  token,
  config,
}: BaseApiParams<SetTeamAiEnabledPayload>) =>
  putApiGalaxyServer<Omit<SetTeamAiEnabledPayload, 'teamId'>, SetTeamAiEnabledResponse>(
    `/ai_api/teams/${teamId}/ai-enabled`,
    { aiEnabled },
    config ?? {},
    token,
  );
